import React from 'react';
import ModalButton from '../../../ModalButton';
import ActivityEntry from '../Components/ActivityEntry';
import { Button } from 'react-bootstrap';
import IActivity from '../../../../interfaces/IActivity';

interface ActivityModalProps {
    editableActivity: IActivity;
    isValid: (activity: IActivity) => boolean;
    handleAddNewActivity: (event?: React.MouseEvent) => void;
    handleEditableActivityUpdate: (name: string, value: any) => void;
    generateNewActivityTemplate: () => IActivity;
    keepModalOpen: boolean;
    setKeepModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setEditableActivity: (activity: IActivity) => void;
}

const ActivityModal: React.FC<ActivityModalProps> = ({
    editableActivity,
    isValid,
    handleAddNewActivity,
    handleEditableActivityUpdate,
    generateNewActivityTemplate,
    setKeepModalOpen,
    setEditableActivity,
}) => {
    return (
        <ModalButton
            modalProps={{ size: 'lg' }}
            confirmBtnText={'Save and close'}
            onConfirmModalBtn={(e) => {
                setKeepModalOpen(false);
                handleAddNewActivity();
            }}
            cancelBtnText={'Close'}
            onCancelModalBtn={() => setEditableActivity(generateNewActivityTemplate())}
            modalTitle={'Add activity'}
            buttonText={
                <>
                    <i className={'bi bi-plus-circle me-3'} />
                    Add activity
                </>
            }
            buttonProps={{
                variant: 'outline-secondary',
                className: 'fs-6',
                size: 'lg',
            }}
            cancelButtonProps={{
                variant: 'outline-secondary',
                className: 'fs-6',
            }}
            confirmButtonProps={{
                className: 'text-primary fs-6',
                disabled: !isValid(editableActivity),
            }}
            additionalButtons={
                <Button
                    className={'text-primar fs-6'}
                    data-testid="confirm-and-close-button"
                    disabled={!isValid(editableActivity)}
                    variant="secondary"
                    onClick={() => {
                        setKeepModalOpen(true);
                        handleAddNewActivity();
                    }}
                >
                    Save and add another
                </Button>
            }
        >
            <ActivityEntry
                activity={editableActivity}
                handleInputChange={handleEditableActivityUpdate}
            />
        </ModalButton>
    );
};
export default ActivityModal;
